<template>
  <div class="order-status-modal">
    <div class="order-status-toolbar">
      <v-popover
        placement="bottom"
        trigger="click"
        :auto-hide="true"
        popover-class="order-status-help-vue-popover"
        popover-inner-class="order-status-help-inner"
        handle-resize
      >
        <button
          type="button"
          class="order-status-help-trigger"
          aria-label="Справка по статусам"
          title="Справка по статусам"
        >
          <va-icon name="fa fa-question-circle" class="mr-1" />
          Справка по статусам
        </button>
        <template slot="popover">
          <div class="order-status-help">
            <p class="order-status-help__subtitle">Статус заказа (исполнение)</p>
            <ul class="order-status-help__list">
              <li v-for="row in orderHelpItems" :key="row.key">
                <strong>{{ row.title }}</strong>
                {{ row.desc }}
              </li>
            </ul>
            <p class="order-status-help__subtitle order-status-help__subtitle--second">
              Статус оплаты
            </p>
            <ul class="order-status-help__list">
              <li v-for="row in paymentHelpItems" :key="row.key">
                <strong>{{ row.title }}</strong>
                {{ row.desc }}
              </li>
            </ul>
            <div class="order-status-help__footer">
              <span v-close-popover class="order-status-help__close-wrap">
                <va-button type="button" color="primary" size="small">
                  Закрыть справку
                </va-button>
              </span>
            </div>
          </div>
        </template>
      </v-popover>
    </div>
    <form @submit.prevent="onSubmitStatus">
      <div class="status-select-wrap">
        <va-input
          :value="
            (orderInfo.processed_by && orderInfo.processed_by.name) || '—'
          "
          label="Обработал заказ"
          disabled
        />
      </div>
      <div class="status-select-wrap">
        <va-select
          v-model="value_order_status"
          max-height="350px"
          placeholder="Статус заказа"
          label="Статус заказа"
          text-by="name"
          value-by="value"
          :options="orderStatusOptions"
        />
      </div>
      <div class="status-select-wrap mt-3">
        <va-select
          v-model="value_payment_status"
          max-height="350px"
          placeholder="Статус оплаты"
          label="Статус оплаты"
          text-by="name"
          value-by="value"
          :options="paymentStatusOptions"
        />
      </div>
      <div class="mt-4 text-center">
        <va-button
          type="button"
          color="primary"
          @click.stop="$emit('hide', false)"
        >
          Закрыть
        </va-button>
        <va-button type="submit" color="success">Сохранить</va-button>
      </div>
    </form>
  </div>
</template>

<script>
import api from "@/api/axios";
import { VPopover, VClosePopover } from "v-tooltip";

const ORDER_CANCELLED = "cancelled";

function extractSelectValue(raw) {
  if (raw === null || raw === undefined) return "";
  if (typeof raw === "object" && raw !== null && "value" in raw) {
    return raw.value;
  }
  return raw;
}

export default {
  components: {
    VPopover,
  },
  directives: {
    closePopover: VClosePopover,
  },
  props: {
    orderInfo: {
      type: Object,
      require: true,
      default: () => {},
    },
  },
  data() {
    return {
      value_order_status: "",
      value_payment_status: "",
      orderHelpItems: [
        {
          key: "new",
          title: "Новый",
          desc: " — заказ создан; ещё не взят в обработку после проверки.",
        },
        {
          key: "in_work",
          title: "В работе",
          desc: " — проверен/промодерирован и взят в обработку (не про оплату).",
        },
        {
          key: "assembling",
          title: "Собирается",
          desc: " ",
        },
        {
          key: "ready",
          title: "Готов (самовывоз)",
          desc: " ",
        },
        {
          key: "in_delivery",
          title: "Передан курьеру",
          desc: " ",
        },
        {
          key: "completed",
          title: "Завершён",
          desc: " — при этом оплата в системе всегда «Оплачен».",
        },
        {
          key: "reject",
          title: "Отменить заказ",
          desc: " — отмена исполнения; для онлайна при необходимости оформите возврат отдельно по оплате.",
        },
      ],
      paymentHelpItems: [
        {
          key: "pending_payment",
          title: "Ожидает оплаты",
          desc: " — по сути не оплачен (включая наложку до приёмки).",
        },
        {
          key: "waiting_confirmation",
          title: "Ожидает подтверждения",
          desc: " — онлайн: банк обрабатывает платёж.",
        },
        {
          key: "paid",
          title: "Оплачен",
          desc: " — деньги зафиксированы; может сочетаться с любым этапом исполнения.",
        },
        {
          key: "refunding",
          title: "Возврат",
          desc: " — возврат в процессе.",
        },
        {
          key: "refunded",
          title: "Возвращён",
          desc: " — возврат завершён.",
        },
      ],
      orderStatusOptions: [
        { id: 1, name: "Новый", value: "new" },
        { id: 2, name: "В работе", value: "in_work" },
        { id: 3, name: "Собирается", value: "assembling" },
        { id: 4, name: "Готов (самовывоз)", value: "ready" },
        { id: 5, name: "Передан курьеру", value: "in_delivery" },
        { id: 6, name: "Завершён", value: "completed" },
        { id: 7, name: "Отменить заказ", value: ORDER_CANCELLED },
      ],
      paymentStatusOptions: [
        { id: 1, name: "Ожидает оплаты", value: "pending_payment" },
        {
          id: 2,
          name: "Ожидает подтверждения оплаты",
          value: "waiting_for_paid_confirmation",
        },
        { id: 3, name: "Оплачен", value: "paid" },
        { id: 4, name: "Возврат средств", value: "refunding" },
        { id: 5, name: "Средства возвращены", value: "refunded" },
      ],
    };
  },
  watch: {
    orderInfo: {
      deep: true,
      immediate: true,
      handler() {
        this.syncFromOrder();
      },
    },
  },
  methods: {
    syncFromOrder() {
      const o = this.orderInfo || {};
      const os = o.order_status != null ? o.order_status : o.status;
      const ps = o.payment_status;
      const orderOpt =
        this.orderStatusOptions.find((x) => x.value === os) || null;
      const payOpt =
        this.paymentStatusOptions.find((x) => x.value === ps) || null;
      this.value_order_status =
        orderOpt || (typeof os === "string" ? { name: os, value: os } : "");
      this.value_payment_status =
        payOpt || (typeof ps === "string" ? { name: ps, value: ps } : "");
    },
    async onSubmitStatus() {
      try {
        const orderId = this.orderInfo.id;
        const orderStatus = extractSelectValue(this.value_order_status);
        const paymentStatus = extractSelectValue(this.value_payment_status);

        if (!orderStatus && !paymentStatus) {
          alert("Выберите статус заказа и/или оплаты.");
          return;
        }

        if (orderStatus === ORDER_CANCELLED) {
          await api.post(`/admin/orders/${orderId}/status`, {
            order_status: ORDER_CANCELLED,
          });
        } else {
          const body = {};
          if (orderStatus) body.order_status = orderStatus;
          if (paymentStatus) body.payment_status = paymentStatus;
          await api.post(`/admin/orders/${orderId}/status`, body);
        }

        this.$emit("saved");
        this.$emit("hide", false);
      } catch (error) {
        if (error.response && error.response.status === 403) {
          alert(error.response.data.message);
        } else {
          alert(
            error.response?.data?.message ||
              "Произошла ошибка, попробуйте позже."
          );
        }

        this.$emit("hide", false);
        return error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.order-status-modal {
  min-width: 0;
}

.order-status-toolbar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 0.75rem;
}

.order-status-help-trigger {
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.65rem;
  border: none;
  border-radius: 4px;
  background: rgba(25, 118, 210, 0.1);
  color: #1565c0;
  font: inherit;
  font-size: 0.875rem;
  cursor: pointer;
  transition: background 0.15s ease;

  &:hover {
    background: rgba(25, 118, 210, 0.18);
  }
}

.status-select-wrap {
  max-width: 100%;
}
.mt-3 {
  margin-top: 0.75rem;
}
</style>

<style lang="scss">
.tooltip.popover.order-status-help-vue-popover {
  z-index: 20020;
}

.order-status-help-inner {
  max-width: min(380px, 92vw);
  padding: 0.75rem 0.9rem !important;
  text-align: left;
}

.order-status-help {
  max-height: 420px;
  overflow-y: auto;
  padding: 10px;
  background-color: #fff;
  border-radius: 4px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.12);

  &__subtitle {
    margin: 0 0 0.35rem;
    font-size: 0.78rem;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.65);
    text-transform: uppercase;
    letter-spacing: 0.02em;

    &--second {
      margin-top: 0.65rem;
    }
  }

  &__list {
    margin: 0;
    padding-left: 1rem;
    font-size: 0.8rem;
    line-height: 1.4;
    color: #333;

    li {
      margin-bottom: 0.35rem;
    }

    li:last-child {
      margin-bottom: 0;
    }

    strong {
      color: #111;
    }
  }

  &__footer {
    margin-top: 0.75rem;
    padding-top: 0.6rem;
    border-top: 1px solid rgba(0, 0, 0, 0.08);
    text-align: right;
  }

  &__close-wrap {
    display: inline-flex;
  }
}
</style>
